import { resolveBallPageId } from '../utils/ballPageId';
import { getCookieConfig } from '../utils/passport';

import { API_GET_ACTIVITY, API_JOIN_ACTIVITY } from './interface';

import { httpPost } from '@/services/signRequest';
import { isIOS } from '@/utils/os';

interface Res {
    traceId: string;
    errno: number;
    errmsg: string;
    data: { [key: string]: unknown };
}

const commonRequest = async (
    requestUrl: string,
    data?: { [key: string]: unknown }
): Promise<Res> => {
    const pageId = resolveBallPageId();
    const loginData = getCookieConfig();
    const header = {
        'page-id': pageId,
        'country-code': 'MX',
        'business-id': '103',
        'business-scene': 'external_landing_page_v2',
        'didi-fintech-header-content': JSON.stringify({
            token: loginData?.ticket || ''
        }) as string
    };

    const commonData: { [key: string]: unknown } = {
        countryCode: 'MX',
        businessId: 103,
        businessScene: 'external_landing_page_v2',
        userType: '1',
        os: isIOS() ? 'ios' : 'android',
        pageId
    };

    commonData.common = {
        location_country: 'MX',
        ticket: loginData?.ticket || '',
        uid: loginData?.uid || ''
    };

    return httpPost(
        requestUrl,
        { ...data, ...commonData },
        { headers: header }
    ) as Promise<Res>;
};

export const getActivityApi = () => commonRequest(API_GET_ACTIVITY);

export const joinActivityApi = () => commonRequest(API_JOIN_ACTIVITY, {});
